const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const background = '#383C47';

  return {
    customSelect: {
      color: 'white',
      padding: 0,
      borderRadius: '10px',
      background,
      '& > .ant-select-selector': {
        paddingLeft: '10px !important',
      },
      '& > .ant-select-arrow': {
        color: theme.textColor,
      },

      '&.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector':
        {
          borderColor: 'transparent',
          boxShadow: 'none',
        },

      '& .ant-select-item-option-content': {
        color: 'white !important',
      },
      '&.ant-select:not(.ant-select-customize-input) .ant-select-selector': {
        background: 'transparent',
        borderColor: 'transparent',
      },
      '&.ant-select:not(.ant-select-disabled):hover .ant-select-selector': {
        borderColor: 'transparent',
      },

      '&.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector':
        {
          background,
        },
    },
    customDropdown: {
      padding: 0,
      background,
      borderRadius: '10px',
      '& .ant-select-item-option-selected:not(.ant-select-item-option-disabled)': {
        backgroundColor: 'transparent',
      },
      '& .ant-select-item-option-active:not(.ant-select-item-option-disabled)': {
        backgroundColor: 'transparent',
        fontWeight: 400,
      },
      '& .ant-select-item-option:hover ': {
        background: 'rgba(255, 255, 255, 0.10)',
      },
      '& .ant-select-item': {
        color: 'white',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
